export { TabsProps } from './tabs.props';
export { ITabs} from './i-tabs';
export const name = "TabsComponent";
